import { Box, Chip, Tooltip, Typography } from "@mui/material";
import { formatMoney } from "../../../../referencias-tablas/clientes/datoscliente/cuentacorriente/utils/formatMoney";
import { TABLE_VARIANTS } from "./TABLE_VARIANTS";

export const buildColumnsCuentaCorrienteEnvasado = ({
  variant,
  totales = { debito: 0, credito: 0, saldo: 0 },
  copiedId,
  setCopiedId,
}) => {
  const columns = [
    {
      accessorKey: "fecha_emision",
      header: "Fecha",
      muiTableBodyCellProps: { align: "center" },
      maxSize: 50,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        if (!value) return "-";

        const dateStr = value.toString().split("T")[0];
        const [year, month, day] = dateStr.split("-");

        return `${day}/${month}/${year}`;
      },
      Footer: () => <Typography fontWeight={800}>TOTALES</Typography>,
    },

    {
      accessorKey: "origen",
      header: "Tipo",
      maxSize: 50,
    },

    {
      accessorKey: "nro_comprobante",
      header: "Comprobante",
      maxSize: 50,
      Cell: ({ cell, row }) => {
        const value = cell.getValue();
        const isCopied = copiedId === row.original.id;

        const handleCopy = () => {
          navigator.clipboard.writeText(value);
          setCopiedId(row.original.id);
          setTimeout(() => setCopiedId(null), 2000);
        };

        return (
          <Box sx={{ display: "inline-block" }}>
            <Tooltip open={isCopied} title="¡Copiado!" placement="right" arrow>
              <Typography
                onClick={handleCopy}
                sx={{
                  cursor: "pointer",
                  fontFamily: "'Inter', 'Roboto', sans-serif",
                  fontSize: "0.82rem",
                  fontWeight: 500,
                  letterSpacing: "0.03em",
                  "&:hover": {
                    textDecoration: "underline",
                    color: "primary.main",
                  },
                }}
              >
                {value}
              </Typography>
            </Tooltip>
          </Box>
        );
      },
    },

    {
      accessorKey: "fecha_vencimiento",
      header: "Vence el",
      muiTableBodyCellProps: { align: "center" },
      muiTableHeadCellProps: { align: "center" },
      maxSize: 50,
      Cell: ({ cell }) => {
        const value = cell.getValue();

        if (!value || value === "0000-00-00") return "-";

        const dateStr = value.toString().split("T")[0];
        const [year, month, day] = dateStr.split("-");

        return `${day}/${month}/${year}`;
      },
    },
  ];

  if (variant !== TABLE_VARIANTS.PENDIENTE) {
    columns.push({
      accessorKey: "saldoImputado",
      header: "Aplicado",
      size: 20,
      Cell: ({ row }) => {
        const saldoPendiente = Number(row.original.saldoImputado);
        const importeTotal = row.original.importe_total;
        const comprobante = row.original.comprobante?.toLowerCase().trim();
        const estado = row.original.estado?.toLowerCase().trim();

        if (
          saldoPendiente === importeTotal ||
          comprobante === "nota de credito" ||
          comprobante === "nota de debito" ||
          comprobante === "ajuste ctacte" ||
          estado === "anulado"
        ) {
          return null;
        }

        return (
          <Chip
            label={saldoPendiente === 0 ? "Aplicado" : "Parcial"}
            size="small"
            sx={{
              height: 20,
              fontSize: "0.68rem",
              fontWeight: 700,
              borderRadius: "6px",
              backgroundColor: "rgba(245,158,11,0.12)",
              color: "#B45309",
              border: "1px solid rgba(245,158,11,0.25)",
              "& .MuiChip-label": {
                px: 1,
              },
            }}
          />
        );
      },
    });
  }

  columns.push(
    {
      accessorKey: "debe",
      header: "Debe",
      muiTableBodyCellProps: { align: "right" },
      muiTableHeadCellProps: { align: "right" },
      muiTableFooterCellProps: { align: "right" },
      maxSize: 50,
      Cell: ({ cell }) => {
        const value = Number(cell.getValue());
        if (!value) return null;

        return (
          <Typography sx={{ color: "success.main", fontWeight: 600 }}>
            ${formatMoney(value)}
          </Typography>
        );
      },
      Footer: () => (
        <Typography sx={{ color: "success.main", fontWeight: 700 }}>
          ${formatMoney(totales.debito)}
        </Typography>
      ),
    },
    {
      accessorKey: "haber",
      header: "Haber",
      muiTableBodyCellProps: { align: "right" },
      muiTableHeadCellProps: { align: "right" },
      muiTableFooterCellProps: { align: "right" },
      maxSize: 50,
      Cell: ({ cell }) => {
        const value = Number(cell.getValue());
        if (!value) return null;

        return (
          <Typography sx={{ color: "error.main", fontWeight: 600 }}>
            ${formatMoney(value)}
          </Typography>
        );
      },
      Footer: () => (
        <Typography sx={{ color: "error.main", fontWeight: 700 }}>
          ${formatMoney(totales.credito)}
        </Typography>
      ),
    },
    {
      accessorKey: "saldo_cta_cte",
      header: "Saldo",
      muiTableBodyCellProps: { align: "right" },
      muiTableHeadCellProps: { align: "right" },
      muiTableFooterCellProps: { align: "right" },
      maxSize: 50,
      Cell: ({ cell }) => {
        const value = Number(cell.getValue());

        return (
          <Typography
            sx={{
              color: value >= 0 ? "success.main" : "error.main",
              fontWeight: 600,
            }}
          >
            ${formatMoney(value)}
          </Typography>
        );
      },
      Footer: () => (
        <Typography
          sx={{
            color: totales.saldo >= 0 ? "success.main" : "error.main",
            fontWeight: 700,
          }}
        >
          ${formatMoney(totales.saldo)}
        </Typography>
      ),
    },
    {
      accessorKey: "nro_remito",
      header: "N° Remito",
      maxSize: 50,
      muiTableBodyCellProps: { align: "right" },
      muiTableHeadCellProps: { align: "right" },
    },
  );

  return columns;
};
